module.exports = __webpack_public_path__ + "img/banner.6004e9a5.png";